"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var newsletter_exports = {};
__export(newsletter_exports, {
  Newsletter: () => Newsletter
});
module.exports = __toCommonJS(newsletter_exports);
var Newsletter;
((Newsletter2) => {
  let Subscribe;
  ((Subscribe2) => {
    Subscribe2.path = "newsletter/subscribe";
  })(Subscribe = Newsletter2.Subscribe || (Newsletter2.Subscribe = {}));
  let Unsubscribe;
  ((Unsubscribe2) => {
    Unsubscribe2.path = "newsletter/unsubscribe";
  })(Unsubscribe = Newsletter2.Unsubscribe || (Newsletter2.Unsubscribe = {}));
  let UnsubscribeByAccount;
  ((UnsubscribeByAccount2) => {
    UnsubscribeByAccount2.path = "newsletter/unsubscribeByAccount";
  })(UnsubscribeByAccount = Newsletter2.UnsubscribeByAccount || (Newsletter2.UnsubscribeByAccount = {}));
})(Newsletter || (Newsletter = {}));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Newsletter
});
